const namespace = 'INVOICES';

export const REQUEST_INVOICES = `${namespace}/REQUEST_INVOICES`;
export const RECEIVE_INVOICES_SUCCESS = `${namespace}/RECEIVE_INVOICES_SUCCESS`;
export const RECEIVE_INVOICES_FAILURE = `${namespace}/RECEIVE_INVOICES_FAILURE`;
